<script setup>
import KitError from "@/components/approval-center/partials/kit/KitError.vue";
import KitWink from "@/components/approval-center/partials/kit/KitWink.vue";
import KitDefault from "@/components/approval-center/partials/kit/KitDefault.vue";
import KitSuccess from "@/components/approval-center/partials/kit/KitSuccess.vue";
import KitThinking from "@/components/approval-center/partials/kit/KitThinking.vue";

defineProps({
  state: {
    type: String,
    default: 'default',
    validator: (value) => [
      'default',
      'success',
      'error',
      'thinking',
      'wink',
    ].includes(value)
  }
});

const iconMap = {
  default: KitDefault,
  success: KitSuccess,
  error: KitError,
  thinking: KitThinking,
  wink: KitWink,
};
</script>

<template>
  <component
    :is="iconMap[state]"
    class="tw-shrink-0 tw-w-16 tw-h-auto"
  />
</template>
